<template>
    <common-page :app-title="'定制图:' + diagramCode">
        <CustomizedDiagram id="diagram"
                           :diagram-code="diagramCode"></CustomizedDiagram>
    </common-page>
</template>

<script>
import CustomizedDiagram from "@/components/LayoutMaps/openLayers/CustomizedDiagram";
import CommonPage from "@/components/echarts-part/stuff/CommonPage";
import screenFull from "screenfull";

export default {
    name: "CustomizedDiagramPage",
    components: {CommonPage, CustomizedDiagram},
    data() {
        return {
            diagramCode: ''
        }
    },
    created() {
        if (this.$route.query.diagramCode) {
            this.diagramCode = this.$route.query.diagramCode;
        }
    },
    mounted() {
        document.addEventListener('keydown', this.whenKeyDown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.whenKeyDown);
    },
    methods: {
        whenKeyDown(event) {
            if (event) {
                if (event.code === 'Escape') {
                    screenFull.exit();
                } else if (event.code === 'F9') {
                    screenFull.request(document.getElementById('diagram'));
                    event.preventDefault();
                }
            }
        },
    },
}
</script>

<style scoped>

</style>